<template>
	<div class="basic_wrap">
		<div class="backgroud_bg">
			<img src="../images/index/home_bg.jpg" alt="" style="width: 100%;">
		</div>
		<!-- 输入框 -->
		<div class="input_tab">
			<div class="input_box">
				<div class="input_box_1" v-show="box1">
					<div class="box_1">
						<div class="box_tab">请填写个人追梦人ID号</div>
						<input type="number" class="putbox" v-model="ymChat" placeholder="请填写个人追梦人ID号">
					</div>
					<div class="box_2">
						<div class="box_tab">请填写个人实名手机号码</div>
						<input type="number" class="putbox" v-model="phone" placeholder="请填写个人实名手机号码">
					</div>
					<div class="btn_tab" @click="changeInputBox(1)">
						<img src="../images/index/btn-input.png" alt="" style="width: 100%;">
					</div>
				</div>
				<div class="input_box_1" v-show="box2">
					<div class="box_1">
						<div class="box_tab">请填写个人圆梦签到ID号</div>
						<input type="text" class="putbox" v-model="ymSign" placeholder="请填写个人圆梦签到ID号">
					</div>
					<div class="box_2">
						<div class="box_tab">请填写个人圆梦新征程ID号</div>
						<input type="text" class="putbox" v-model="ymXzc" placeholder="请填写个人圆梦新征程ID号">
					</div>
					<div class="btn_tab" @click="changeInputBox(2)">
						<img src="../images/index/btn-input.png" alt="" style="width: 100%;">
					</div>
				</div>
				<div class="input_box_1" v-show="box3">
					<div class="box_1">
						<div class="box_tab">请填写个人圆梦夜听ID号</div>
						<input type="text" class="putbox" v-model="ymYt" placeholder="请填写个人圆梦夜听ID号">
					</div>
					<div class="box_2">
						<div class="box_tab">请填写个人团长编号</div>
						<input type="text" class="putbox" v-model="team" placeholder="请填写个人团长编号">
					</div>
					<div class="btn_tab" @click="changeInputBox(3)">
						<img src="../images/index/btn-input.png" alt="" style="width: 100%;">
					</div>
				</div>
				<div class="input_box_1 input_box_last" v-show="box4">
					<div class="box_1">
						<div class="box_tab">请填写上级追梦ID号</div>
						<input type="number" class="putbox" v-model="firstId" placeholder="请填写上级追梦ID号">
					</div>
					<div class="btn_tab" @click="changeInputBox(4)">
						<img src="../images/index/btn-input.png" alt="" style="width: 100%;">
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import Fetch from '../../utils/fetch';
	import Api from "../../interface/index";

	export default {
		name: "Information",
		components: {},
		data() {
			return {
				data: {},
				ymChat:'',
				phone:'',
				ymSign:'',
				ymXzc:'',
				ymYt:'',
				team:'',
				firstId:'',
				box1:true,
				box2:false,
				box3:false,
				box4:false,
			};
		},
		created() {
			this.$parent.footer('info', false);
		},
		mounted() {
			// this.start();
			// console.log(this.formattedDate())
		},
		methods: {
			start(obj) {
				Fetch('/index/userinfo','post', {
					user_id: this.ymChat,
					phone: this.phone,
				}).then(res => {
					if(res.code == 1){
						this.$toast({
							className:"toastName",
							message: res.msg,
						});
					}else{
						this.$toast({
							className:"toastName",
							message: res.msg,
						},2000);
						this.data = res.data;
						localStorage.setItem('login_userlevel', this.data.userinfo.level);
						localStorage.setItem('login_userid', this.data.userinfo.user_uid);
						localStorage.setItem('login_usernickname', this.data.userinfo.nickname);
						localStorage.setItem('login_userphone', this.data.userinfo.phone);
						if(this.data.usercode){
							localStorage.setItem('login_collective2', this.data.usercode.collective2);
							localStorage.setItem('login_collective3', this.data.usercode.collective3);
							localStorage.setItem('login_personal2', this.data.usercode.personal2);
							localStorage.setItem('login_personal3', this.data.usercode.personal3);
							localStorage.setItem('login_addressarea', this.data.usercode.address_area);
							localStorage.setItem('login_addressphone', this.data.usercode.address_phone);
							localStorage.setItem('login_createtime', this.data.usercode.create_time);
							this.ymSign = this.data.usercode.ymqd_code;
							this.ymXzc = this.data.usercode.ymxzc_code;
							this.ymYt = this.data.usercode.ymyt_code;
							this.team = this.data.usercode.tz_code;
							this.firstId = this.data.usercode.frist_leader;
						}
						this.ymChat = this.ymChat;
						this.phone = this.phone;
						setTimeout(() => {
							this.box1 = false;
							this.box2 = true;
						}, 2000);
						
					}
				})
			},
			savedata(){
				Fetch('/index/addUserCode','post', {
					user_id: this.ymChat,
					phone: this.phone,
					ymqd_code: this.ymSign,
					ymxzc_code: this.ymXzc,
					ymyt_code: this.ymYt,
					tz_code: this.team,
					frist_leader: this.firstId,
				}).then(res => {
					if(res.code == 1 || res.code == 2){
						this.$toast({
							className:"toastName",
							message: res.msg,
						});
						this.box1 = false;
						this.box2 = true;
						this.box3 = false;
						this.box4 = false;
					}else if(res.code == 3){
						this.$toast({
							className:"toastName",
							message: res.msg,
						});
						this.box1 = false;
						this.box2 = false;
						this.box3 = true;
						this.box4 = false;
					}else if(res.code == 4){
						this.$toast({
							className:"toastName",
							message: res.msg,
						});
						this.box1 = false;
						this.box2 = false;
						this.box3 = false;
						this.box4 = true;
					}else{
						this.$toast({
							className:"toastName",
							message: res.msg,
						});
						localStorage.setItem('login_createtime', this.formattedDate());
						setTimeout(() => {
							this.$router.push('/infoResult');
						}, 2000);
					}
				})
			},
			changeInputBox(obj){
				if(obj == 1){
					this.start();
				}else if(obj == 2){
					this.box2 = false;
					this.box3 = true;
				}else if(obj == 3){
					this.box3 = false;
					this.box4 = true;
				}else if(obj == 4){
					this.savedata();
				}
			},
			formattedDate() {
			  const date = new Date();
			  const year = date.getFullYear();
			  const month = ('' + (date.getMonth() + 1)).slice(-2); // 月份是从0开始的
			  const day = ('' + date.getDate()).slice(-2);
			  return year + '-' + month + '-' + day;
			},
		},
	};
</script>

<style lang="less" scoped>
	.backgroud_bg{
		position: absolute;
		z-index: 1;
		top: 0;
		left: 0;
	}
	.input_tab {
	    position: absolute;
	    width: 100%;
	    z-index: 9;
	    top: 28vh;
	}
	.input_box {
	    position: relative;
	    text-align: center;
	    width: 100%;
	}
	.input_box_1 {
	    position: relative;
	    width: 80%;
	    left: 10%;
		
		.box_tab {
		    font-size: 0.65rem;
		    font-weight: 600;
		    color: red;
		}
		.putbox {
		    border: 2px solid rgb(54 179 242);
		    margin-top: 0.2rem;
		    position: relative;
		    margin-bottom: 0.2rem;
		    height: 0.85rem;
		    width: 90%;
		    background-color: #fff;
			    font-size: 0.45rem;
		}
	}
	.btn_tab {
	    position: relative;
	    top: 0.3rem;
	    width: 90%;
	    left: 5%;
	}
	.input_box_last {
	    position: relative;
	    top: 1rem;
	}
</style>
